import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fa-regular fa-tree-palm"
};
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimeOffMainTimeTableCell',
    props: {
        node: {},
        intervalId: {},
        field: {}
    },
    setup(__props) {
        const props = __props;
        const timeInterval = computed(() => {
            return props.node.timeIntervalValues.find((timeInterval) => timeInterval.id === props.intervalId);
        });
        const isTimeOff = computed(() => {
            return timeInterval.value?.timeOff;
        });
        const getClasses = () => {
            const warningColor = "bg-orange-50 dark:bg-orange-950 border-surface-100 !text-orange-500";
            const weekendOrHolidayColor = "!bg-surface-50 dark:!bg-surface-0 !border-surface-100";
            if (!isWorkingDay.value)
                return weekendOrHolidayColor;
            else if (isTimeOff.value)
                return warningColor;
            else
                return "";
        };
        const isWorkingDay = computed(() => {
            return (timeInterval.value?.dayType === "WORKDAY" ||
                timeInterval.value?.dayType === "EXTRA_WORKDAY");
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["min-w-[100px] h-[56px] flex items-center justify-center border-surface-100 text-surface-950 text-sm font-normal border-r border-b", ['font-semibold', getClasses()]])
            }, [
                (isTimeOff.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_1))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
